import { CoachingActions } from 'actions/actionTypes';

const initialState = {
  speakerChanges: [],
  userIds: {},
  screenNames: {},
  coachingRecommendation: null
};

const coaching = (state = initialState, action) => {
  switch (action.type) {
    case CoachingActions.SPEAKER_EVENT: {
      return {
        ...state,
        speakerChanges: [
          ...state.speakerChanges,
          {
            timestamp: action.timestamp,
            status: action.status,
            service: action.service
          }
        ]
      };
    }
    case CoachingActions.SET_USER_ID: {
      return {
        ...state,
        userIds: {
          ...state.userIds,
          [action.service]: action.userId
        }
      };
    }
    case CoachingActions.SET_SCREEN_NAME: {
      return {
        ...state,
        screenNames: {
          ...state.screenNames,
          [action.service]: action.screenName
        }
      };
    }
    case CoachingActions.SET_COACHING_RECOMMENDATION_UUID_TO_FETCH: {
      return {
        ...state,
        coachingRecommendation: action.response
      };
    }
    case CoachingActions.EMPTY_COACHING_RECOMMENDATION_UUID_TO_FETCH: {
      return {
        ...state,
        coachingRecommendation: null
      };
    }
    default:
      return state;
  }
};

export default coaching;
